import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NoticeOfIntentChangeRequestStep7Form from '../../../../components/forms/postSecondary/NoticeOfIntentChangeRequestStep7Form';
import Routes from '../../../../config/Routes';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NoticeOfIntentStep6PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface NoticeOfIntentStep6PageProps {
  currentUser: UserSecurity | null;
}

class NoticeOfIntentStep6Page extends React.Component<NoticeOfIntentStep6PageProps & RouteComponentProps<RouteObject>, NoticeOfIntentStep6PageState> {
  private readonly _formRef = React.createRef<NoticeOfIntentChangeRequestStep7Form>();

  constructor(props: NoticeOfIntentStep6PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id == 'new') {
      this.setState({ isNew: true });
    }
    else if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_6, { id: this.state.changeRequestId }, {}))
  }

  private goToNextStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_8, { id: this.state.changeRequestId }));
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={6}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Linking And Existing Entities" >
            <NoticeOfIntentChangeRequestStep7Form
              ref={this._formRef}
              changeRequestId={this.state.changeRequest.id}
              isNew={this.state.isNew}
              onSubmit={this.goToNextStep}
              onPrevious={this.goToPreviousStep}
              loading={this.state.loading} />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(NoticeOfIntentStep6Page));